<div class="okr-views-cell-contents text-color-gray-10" [ngSwitch]="column.type">
  <div class="text-icon-container sp-ml-16 sp-mr-16" *ngSwitchCase="'alphabetic'" [id]="column.fieldName + '-' + item.id">
    <i class="fs-16px sp-mr-7" ui-icon uiType="shareable_filter" uiTheme="fill"></i>
    <span
      class="fs-14px text-color-primary-8 link text-container"
      [uiTooltipTitle]="item.name"
      [uiParams]="{ okrViewId: item.id }"
      uiSref="gtmhub.okrView"
      ui-tooltip
      tooltipIfOverflow="hover"
      uiTooltipPlacement="bottom"
      >{{ item.name }}</span
    >
  </div>
  <div class="sp-ml-16 sp-mr-16" *ngSwitchCase="'user'" [id]="column.fieldName + '-' + item.id">
    <ui-assignee [fromAssigneeId]="item.ownerId" [uiNameEllipsis]="true" uiSize="sm"></ui-assignee>
  </div>
  <div class="sp-ml-16 sp-mr-16" *ngSwitchCase="'permissions'" [id]="column.fieldName + '-' + item.id" [ngSwitch]="item.access">
    <okr-views-grid-access-cell [accessType]="mapAccessObjectToSimplePermissions(item.access)"></okr-views-grid-access-cell>
  </div>
</div>
